import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import './styles.css';
import { App } from './App.tsx';
import { setLocale } from './i18n.ts';
import { applyStoredTheme } from './theme.ts';

applyStoredTheme();
setLocale(navigator.language || 'en');
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
